import type { JSX } from "react";
import { Stack, Typography } from "@mui/material";
import { useLocation } from "react-router";


export const NotFound = (): JSX.Element => {
	const location = useLocation();

	return (
		<Stack sx={{ alignItems: "center", py: 16 }}>
			<Typography variant="h1">Page Not Found</Typography>
			<Typography>
				No page found at <strong>{ location.pathname }</strong>.
			</Typography>
		</Stack>
	);
};
